import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromNewsletters from '../reducers/newsletters.reducer';
import * as fromRoot from '../../../store';

export const getNewslettersState = createSelector(
  fromFeature.getNewslettersModuleState,
  (state: fromFeature.NewslettersModuleState) => state.newsletters
);
export const getNewsletterSubscriptionResult = createSelector(getNewslettersState, fromNewsletters.getNewsletterSubscriptionResult);
export const getNewsletterSubscriptionError = createSelector(getNewslettersState, fromNewsletters.getNewsletterSubscriptionError);
export const getNewsletterSubscribed = createSelector(getNewslettersState, fromNewsletters.getNewsletterSubscribed);
export const getNewsletterSubscribing = createSelector(getNewslettersState, fromNewsletters.getNewsletterSubscribing);
export const getNewsLetterShowWindow = createSelector(getNewslettersState, state => {
  return state.showWindow;
});
export const getNewsLetterShowWindowSettingsInitialized = createSelector(getNewslettersState, fromNewsletters.getInitNewsletterPopup);
